<template>
  <!-- MAIN -->
  <div class="col">
    <div id="main" class="col-main">
      <!-- INTRO -->
      <div class="row no-gutters row-main justify-content-center">
        <div class="col-12 col-lg-10 bg-white">
          <div class="row no-gutters justify-content-center">
            <div class="col-12 col-lg-9">
              <h2 class="section-title">Welcome to Ealing Trailfinders Cricket Club</h2>
            </div>

            <div class="col-12 col-lg-9">
              <!-- Text -->
              <p class="h5">
               Ealing Trailfinders Cricket Club play at Trailfinders Sports Club, Ealing. 
              </p>
              <p class="h5 text-strong">
                We are a progressive, ambitious, friendly cricket club with both adult and junior sections.
                <br/>
                <br/>
                With outstanding all year-round facilities, a professional coaching team, we provide the best possible environment to enjoy and develop your cricket.
              </p>
          
                <p class="h5">Join our community <a href="#/register?form=adult">here</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchNews } from "@/services/api";
import { Carousel, Slide } from "vue-carousel";
import EventBus from '../eventBus'

export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      // news: [],
      year: ""
    };
  },
  // created() {
  //   this.fetchList();
  // },
  mounted() {
    EventBus.$on("get-year", (year) => {
      this.year = year
    })
  },
  // methods: {
  //   fetchList() {
  //     fetchNews().then((response) => {
  //       const news = response.sort(
  //         (a, b) => new Date(b.publish_date) - new Date(a.publish_date)
  //       );
  //       this.news = [];
  //       for (let value of news) {
  //         if (value.status === "Live") {
  //           let day = new Date(value.publish_date).toLocaleString("default", {
  //             day: "2-digit",
  //           });
  //           let month = new Date(value.publish_date).toLocaleString("default", {
  //             month: "long",
  //           });
  //           let year = new Date(value.publish_date).getFullYear();
  //           value.readableDate = day + " " + month + " " + year;
  //           this.news.push(value);

  //           if (this.news.length === 3) {
  //             break;
  //           }
  //         }
  //       }
  //     });
  //   },
  // },
};
</script>
